import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, isRef as _isRef, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9c2a9606"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "entry_base_contents_wrapper" }
const _hoisted_2 = { class: "entry_base_indicator_wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "entry_base_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "entry_base_title_text" }, "性別を教えてください")
], -1))
const _hoisted_4 = { class: "entry_base_input" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "性別"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須")
], -1))
const _hoisted_6 = { class: "entry_base_input_layout_column_2" }
const _hoisted_7 = { class: "entry_base_button" }
const _hoisted_8 = { class: "entry_base_button_prev" }
const _hoisted_9 = { class: "entry_base_button_next" }

import { ref, computed, onMounted, onBeforeMount, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useField, useForm } from 'vee-validate';
import { object, string } from 'yup';
import { getMasterDataList, Master } from '@/api/entryMasterDataEndpoint';
import alertOnReload from '@/utils/alertOnReload';
import store from '@/store';
import Indicator from '@/components/Indicator.vue';
import BaseTextForm from '@/components/BaseTextForm.vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseRadioButton from '@/components/BaseRadioButton.vue';
import BaseYmdForm from '@/components/BaseYmdForm.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import VALIDATON_ERRORS from '@/constants/validationErrors';


export default /*#__PURE__*/_defineComponent({
  __name: 'SexView',
  setup(__props) {

const sexList = ref<Master[]>([]);

const schema = object({
  sexFlg: string().required(),
});

const { meta, errors } = useForm({
  validationSchema: schema,
});

const { value: sexFlg } = useField('sexFlg', undefined, {
  initialValue: store.getters['userRegistration/sexFlg'],
});

const router = useRouter();
const transitionPage = () => {
  store.commit('userRegistration/setSexFlg', sexFlg.value);
  router.push({ name: 'b05' });
};
const transitionPreviousPage = () => {
  router.push({ name: 'b03' });
};

watch(sexFlg, (newVal) => {
  if (newVal !== null && newVal !== undefined) {
    store.commit('userRegistration/setSexFlg', sexFlg.value);
    router.push({ name: 'b05' });
  }
});

onBeforeMount(async () => {
  const token = store.getters['userRegistration/token'] as string;
  if (!token) {
    router.push({ name: 'b11' });
    return;
  }
  getMasterDataList('sex')
    .then((res) => {
      sexList.value = res;
    })
    .catch((e) => {
      console.error(e);
    });
});
alertOnReload();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Indicator, {
          current: 6,
          max: 8
        })
      ]),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sexList.value, (sexItem) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "entry_base_input_layout_column_2_item",
              key: sexItem.code
            }, [
              _createVNode(BaseRadioButton, {
                label: sexItem.name,
                name: "sex",
                value: sexItem.code,
                modelValue: _unref(sexFlg),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(sexFlg) ? (sexFlg).value = $event : null)),
                modelModifiers: { number: true }
              }, null, 8, ["label", "value", "modelValue"])
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(BaseButton, {
            onClick: transitionPreviousPage,
            theme: "tertiary",
            type: "button"
          }, {
            default: _withCtx(() => [
              _createTextVNode("戻る")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(BaseButton, {
            onClick: transitionPage,
            theme: "primary",
            type: "button",
            disabled: !_unref(meta).valid
          }, {
            default: _withCtx(() => [
              _createTextVNode("次へ")
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ])
  ]))
}
}

})